import React, { useState, useEffect } from 'react';
import { navigate } from '@reach/router';
import { Helmet } from 'react-helmet';
import '../../styles/style.scss';
import 'sanitize.css/sanitize.css';

export default function LayoutWrapper(props) {
  const [headScript, setHeadScript] = useState(false);

  if (typeof window !== 'undefined') {
    // Detect lang browser and redirect to language homepage
    if (window.location.pathname === '/') {
      const userLang = navigator.language;
      if (props.props.data.polylang_current_lang) {
        navigate(`/${userLang}/`);
      } else {
        navigate('/fr');
      }
    }

    useEffect(() => {
      const lang = props.props.data.allWordpressPage.edges[0].node.polylang_current_lang;
      props.props.data.allWordpressPage.edges
        .filter((item) => item.node.polylang_current_lang === lang && item.node.acf !== null && item.node.acf.head_script)
        .map((item) => {
          setHeadScript(item.node.acf.head_script);
        });
    })

    // Keep source in storage, for utm's sended on LP Worker
    if (!sessionStorage.getItem('utm_source')) {
      sessionStorage.setItem('utm_source', document.referrer ? document.referrer : 'none');
    }
  };

  const preventDragHandler = (e) => {
    e.preventDefault();
  };

  return (
    <div onDragStart={(e) => preventDragHandler(e)}>
      <Helmet>
        <script>{headScript}</script>
      </Helmet>
      {props.children}
    </div>
  );
}
